import { defineMessages } from 'react-intl';

export const bookDemoEmailStepMessages = defineMessages({
  title: {
    defaultMessage: 'Book a demo',
    id: '63v8NIMUo5',
    description: 'Heading on the book demo email step',
  },
  subtitle: {
    defaultMessage: 'Book a demo with our team',
    id: 'Xg6BAutfbz',
    description: 'Subheading on the book demo email step',
  },
  workEmailLabel: {
    defaultMessage: 'Work email',
    id: 'f95s2hP7u6',
    description: 'Label for work email field on book demo step',
  },
  workEmailPlaceholder: {
    defaultMessage: 'name@company.com',
    id: 'rw5VLtD+SM',
    description: 'Placeholder for work email on book demo step',
  },
  orDivider: {
    defaultMessage: 'or',
    id: '78BFzwxrCS',
    description: 'Divider between email and social login options',
  },
  continueWithGoogle: {
    defaultMessage: 'Continue with Google',
    id: '2C5DYJ1Cub',
    description: 'Button to continue book demo signup with Google',
  },
  continueWithApple: {
    defaultMessage: 'Continue with Apple',
    id: 'nZRE6lqnze',
    description: 'Button to continue book demo signup with Apple',
  },
  continue: {
    defaultMessage: 'Continue',
    id: 'yQB9ITetvu',
    description: 'Primary button to continue with email on book demo step',
  },
  back: {
    defaultMessage: 'Back',
    id: 'KWwo96yMcv',
    description: 'Button to go back from book demo email step',
  },
  brandIconAlt: {
    defaultMessage: 'Heidi',
    id: 'yKlzkyJ7zu',
    description: 'Alt text for Heidi brand logo on book demo step',
  },
  googleLogoAlt: {
    defaultMessage: 'google logo',
    id: 'XoXdrQ6tsl',
    description: 'Alt text for Google logo on book demo social login button',
  },
  appleLogoAlt: {
    defaultMessage: 'apple logo',
    id: '1s8LTGgZ2M',
    description: 'Alt text for Apple logo on book demo social login button',
  },
});
